import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  background: ${({ headerBGColor }) => headerBGColor || 'var(--color-primary)'};
  align-items: center;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
`;

const StyledLogo = styled.img`
  margin-inline-start: 20px;
  margin-top: 14px;
  margin-bottom: 14px;
  height: 34px;
  display: block;
`;

const Link = styled.a`
  color: ${({ buttonTextColor }) => buttonTextColor || 'var(--color-primaryButtonText)'};
  ${({ theme }) => theme.fontSize('16px')};
  margin: auto 10px;
  text-decoration: none;
`;

const LinkWrapper = styled.div`
  margin-block: auto;
  margin-inline: auto 19px;
`;

export const Header = ({ logoIconUrl, logoLinkUrl, linkUrls, headerBGColor, buttonTextColor }) => {
  return (
    <Wrapper headerBGColor={headerBGColor}>
      <a href={logoLinkUrl} target="_blank">
        <StyledLogo src={logoIconUrl} alt="logo" />
      </a>
      <LinkWrapper>{linkUrls ? generateTextLinks(linkUrls, buttonTextColor) : null}</LinkWrapper>
    </Wrapper>
  );
};

const generateTextLinks = (linkUrls, buttonTextColor) =>
  linkUrls.map(({ text, url, target }) => {
    // Was going to try and preserve state, but would require click-time URL changes, not render time.
    // if (preserveState)
    //   url += location.search.includes('?') ? '&s=' : '?s=' + queryString.parse(location.search).s
    return (
      <Link href={url} target={target || '_blank'} key={`text_link_${text}`} buttonTextColor={buttonTextColor}>
        {text}
      </Link>
    );
  });
